import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";
import { UserForInternalActivityPanel } from "../activity/UserForInternalActivityPanel";
import TransferUserData from "../TransferUserData";
import TransferUserOptionsPanel from "../TransferUserOptionsPanel";

export const UserForInternalTransferApp = () => {
  const viewModel = useLoaderData<server.viewmodel.InternalUserToClientTransferFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <TransferUserData
            stats={viewModel.userToClientUsage}
            clientConfig={viewModel.clientConfig}
            sourceUserToClient={viewModel.userForInternalAdmin}
          />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <TransferUserOptionsPanel
            optionsPanelData={viewModel.optionsPanel}
            listUrl={viewModel.listUrl}
            userToClient={viewModel.userForInternalAdmin}
            userSmall={viewModel.userForInternalAdmin.user}
          />
          <UserForInternalActivityPanel
            userToClientId={viewModel.userForInternalAdmin.userToClientId}
            config={viewModel.activityPanel}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={site.navigation.rightSideNavigation.title}
      menuItems={site.navigation.rightSideNavigation.items}
      currentPage={site.currentPage}
    />
  </TwoColumnLayout>
}